import PropTypes from "prop-types";
import React, { useState } from "react";

const ReadMoreParagraph = ({ text, maxLength = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const shouldTruncate = text?.length > maxLength;

  const displayedText = isExpanded || !shouldTruncate
    ? text
    : `${text.slice(0, maxLength)}...`;

  return (
    <div>
      <p>
        {displayedText}
        {shouldTruncate && (
          <button onClick={toggleReadMore} style={{ all: "unset", border: "none", background: "none", color: "blue", cursor: "pointer", fontSize: '13px' }} className="mx-4" aria-expanded={isExpanded}>
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        )}
      </p>

    </div>
  );
};

ReadMoreParagraph.propTypes = {
  text: PropTypes.string.isRequired,
  length: PropTypes.number,
  maxLength: PropTypes.number,
};

export default ReadMoreParagraph;
